import "./RightBanner.scss"

export const RightBanner = () => {
  return (
    <a href="https://t.me/FacimexValores" target="_blank" rel="noopener" style={{height:"fit-content"}}>
        <img src="/assets/banners/BannerDER_APP_2.png" alt="Telegram Invite" id="RightBanner" className="center-block"/>
    </a>
  )
}
